export const numberRemoveSeparator = (value: string): string => {
  return value.replace(/\D/g, "");
};
